export default "__VITE_ASSET__CTdHQiEn__"